import Image from 'next/image';
import { FC } from 'react';

import style from './NotificationRowAction.module.scss';
import { INotificationRowAction } from './NotificationRowAction.types';

export const NotificationRowAction: FC<INotificationRowAction> = ({
  thumbnailUrl,
}) => {
  if (thumbnailUrl) {
    return (
      <Image
        className={style.image}
        src={thumbnailUrl}
        alt="Notification thumbnail"
        width={80}
        height={80}
        loading="lazy"
      />
    );
  }

  return null;
};
